import React from "react";
import Spinner from "../../spinner";
import "./edit-group.scss";
import { Link } from "react-router-dom";

const statusTypes = {
  1: "#81CC5E", // common_paid
  2: "#F14343", // common_unpaid
  3: "#F89A2B", // no_invoices
  4: "#9f9f9f", // no dynamic status
};

const GroupChildren = (props) => {
  const { data, edit } = props;
  const childs = data?.children;
  if (childs) {
    return (
      <div style={{ height: "100%" }}>
        <div style={{ display: "flex" }}>
          <h2 style={{ margin: 0 }}>Список учеников</h2>
          {edit ? (
            <button onClick={() => edit(true)} className="editChildrenGroup">
              {" "}
              ред.
            </button>
          ) : null}
        </div>
        <div className="listChildrenContainer">
          <ul className="listChildren">
            {childs.map((item) => (
              <Link
                className="listChildrenLink"
                target="_blank"
                to={`/admin/clients/${item.client_id}`}
                key={item.client_id}
              >
                <li>
                  {item.dynamic_status.length ? (
                    item.dynamic_status.map((status) => {
                      return (
                        <span
                          className="dot dot_margined"
                          style={{
                            backgroundColor: statusTypes[status.id],
                          }}
                        />
                      );
                    })
                  ) : (
                    <span
                      className="dot dot_margined"
                      style={{
                        backgroundColor: statusTypes[4],
                      }}
                    />
                  )}
                  {item.last_name} {item.first_name}{" "}
                  {item.middle_name !== null ? item.middle_name : ""}
                </li>
              </Link>
            ))}
          </ul>
        </div>
      </div>
    );
  } else {
    return <Spinner />;
  }
};

export default GroupChildren;
